var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargBluePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5858 4.08579C14.3668 3.30474 15.6332 3.30474 16.4142 4.08579C17.1953 4.86683 17.1953 6.13316 16.4142 6.91421L15.6213 7.70711L12.7929 4.87868L13.5858 4.08579Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3787 6.29289L3 14.6716V17.5H5.82842L14.2071 9.12132L11.3787 6.29289Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargBluePencil);
export default __webpack_public_path__ + "static/media/largBluePencil.b15f4930d9db979919fd554e372d1006.svg";
export { ForwardRef as ReactComponent };